import { Controller } from '@hotwired/stimulus';
import tippy, { roundArrow, sticky } from 'tippy.js';

export default class extends Controller {
  tippyEl = null;

  get textContent() {
    return this.element.dataset.content || this.element.title;
  }

  static values = {
    placement: {
      type: String,
      default: 'auto',
    },
  };

  connect() {
    this.tippyEl = tippy(this.element, {
      trigger: 'mouseenter focus click',
      interactiveBorder: 10,
      content: this.textContent,
      appendTo: this.element,
      allowHTML: true,
      interactive: true,
      sticky: true,
      arrow: roundArrow,
      plugins: [sticky],
      placement: this.placementValue,
    });

    if (!this.element.getAttribute('aria-description')) {
      this.element.setAttribute('aria-description', this.textContent);
    }
  }

  disconnect() {
    this.tippyEl.destroy();
  }
}
